import React, { useEffect, useState } from "react"
import { Column, Container, Row } from "../components/Grid"
import HeroHome from "../components/HeroHome"
import Icon from "../components/Icon"
import Image from "../components/Image"
import Layout from "../components/Layout"
import OutboundLink from "../components/OutboundLink"
import PageCards from "../components/PageCards"
import Section from "../components/Section"
import SEO from "../components/Seo"
import Subscribe from "../components/Subscribe"
import Video from "../components/Video"
import RxBottle from "../images/theme/img-Rx-bottle.png"
import AboutPharmTeach from "../images/theme/img-hp-icon-pharm-teach.png"

const IndexPage = ({ data }) => {
  const [hostname, setHostname] = useState("")
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)
    setHostname(
      window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : "")
    )
  }, [])

  return (
    <Layout>
      <SEO title="Home" />
      {/***************  HERO ***************/}
      <Section className="hero__home">
        <HeroHome
          title="Dose of Knowledge"
          subheading="A Pharmacists Teach Program"
          image="img-hp-hero-heart@2x.png"
        />
      </Section>

      {/***************  CALLOUT  ***************/}
      <Section className="callout">
        <Container>
          <Row>
            <Column span={12}>
              <Subscribe
                trigger={
                  <button>
                    <img
                      src={RxBottle}
                      className="rx-bottle"
                      alt="Dose of Knowledge Rx Bottle"
                    />
                    <span>Subscribe for Updates Today!</span>{" "}
                    <Icon name="rightarrow" inline />
                  </button>
                }
              />
            </Column>
          </Row>
        </Container>
      </Section>

      <Section>
        <Container>
          <Row className="home-interactive-row">
            <Column span={6} className="pb-1">
              <h2 className="mt-1">
                Think It Through: A choose-your-own-path experience
              </h2>
              <p>
                Explore an interactive resource designed to empower students to
                make smart, healthy choices when presented with several quick
                fix options.
              </p>
              <div className="resource__action">
                <a href="/educators/#CYOA">
                  <Icon name="module" inline />
                  Learn More
                </a>
              </div>
            </Column>
            <Column span={6}>
              <div style={{ position: "relative" }}>
                <Image filename="CVS-DoK-Educator-Think-It-Through-Animation-L-Thumb@3x.png" />
                <Image
                  filename="CVS-Animation-New-Flag.png"
                  className="new-flag"
                />
              </div>
            </Column>
          </Row>
        </Container>
      </Section>

      {/***************  ABOUT BE VAPE FREE ***************/}
      <Section className="about-program lightgray">
        <Container>
          <Row>
            <Column span={6}>
              <div className="embed-container">
                {" "}
                {loaded && (
                  <Video
                    guidSrc="90c60ac1-1f8c-4f13-b70d-869ec28d7a5b"
                    posterSrc="img-hp-nflpa-adrianna.jpg"
                  />
                )}
              </div>
            </Column>
            <Column span={5}>
              <h2>About the Program</h2>
              <p>
                CVS has taken steps to educate youth through our Pharmacists
                Teach / Dose of Knowledge Program, a no-cost outreach program
                expanded in partnership with Discovery Education which targets
                school-aged children grades K-12, educating them on topics such
                as substance misuse, medication safety, and mental health.
              </p>
            </Column>
          </Row>
        </Container>
      </Section>

      <Section>
        <Container>
          <PageCards
            cards={[
              {
                to: "/educators/",
                label: "Educators",
                image: "img-hero-infographic-educators.png",
                description:
                  "Find standards-aligned resources and easy-to-implement lesson plans and activities to start the conversation with students around topics such as substance misuse, medication safety, and mental health.",
              },
              {
                to: "/pharmacists/",
                label: "Pharmacists",
                image: "img-hero-infographic-pharmacists.png",
                description:
                  "Bring your expertise into the classroom with resources designed to help students make healthy decisions and spark the conversation around substance misuse, medication safety, and mental health.",
              },
              {
                to: "/students/",
                label: "Students",
                image: "img-hero-infographic-students.png",
                description:
                  "Find interactive resources designed to empower students to make smart, healthy choices in the face of peer pressure.",
              },
              {
                to: "/caregivers/",
                label: "Caregivers",
                image: "img-hero-infographic-caregivers.png",
                description:
                  "Support students at home with resources and activities that can be used to guide discussions on topics such as substance misuse and mental health.",
              },
            ]}
          />
        </Container>
      </Section>

      <Section>
        <Container>
          <Row className="home-interactive-row">
            <Column span={6}>
              <div style={{ position: "relative" }}>
                <Image filename="img-home-pharmacy-career-exploration.png" />
              </div>
            </Column>
            <Column span={6} className="pb-1">
              <h2 className="mt-1">Pharmacy Career Exploration</h2>
              <p>
                Discover the role pharmacists play in the health and well-being
                of their community through triaging patients and providing
                immunizations and important information about medications.
                Earning a Doctor of Pharmacy (PharmD) degree is not only a great
                career move, but great for the community.
              </p>
              <div className="resource__action">
                <a href="/pharmacy-careers">
                  <Icon name="module" inline />
                  Learn More
                </a>
              </div>
            </Column>
          </Row>
        </Container>
      </Section>

      {/***************  ABOUT PHARMACISTS TEACH INFO ***************/}
      <Section className="about-pharmacists darkgray-background">
        <Container>
          <Row>
            <Column span={3}>
              <img
                src={AboutPharmTeach}
                className="pharma-teach-placeholder"
                alt="Dose of Knowledge Rx Bottle"
              />
            </Column>
            <Column span={9}>
              <h2>About Pharmacists Teach</h2>
              <p>
                CVS Health created Pharmacists Teach in 2015 to bring
                pharmacists into the classroom to help educate the public about
                substance misuse. The Pharmacists Teach program has expanded to
                include <strong>Dose of Knowledge</strong>, a program created in
                partnership with Discovery Education to provide
                standards-aligned resources to educators and pharmacists across
                the U.S. Since it began, the{" "}
                <strong>Pharmacists Teach / Dose of Knowledge</strong> program
                has impacted millions of lives across the country, empowering
                students to make healthy choices for the well-being of
                themselves and their communities.
              </p>
              <OutboundLink to="https://www.cvshealth.com/social-responsibility/corporate-social-responsibility/pharmacists-teach">
                <button className="global__button darkgray">Learn More</button>
              </OutboundLink>
            </Column>
          </Row>
        </Container>
      </Section>
    </Layout>
  )
}

export const query = graphql`
  query HomePageQuery {
    site {
      siteMetadata {
        gaId
      }
    }
  }
`

export default IndexPage
